import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Box, TextFieldStyled, IconStyled, Button, Icon, inputMediumStyles } from '@bechtel/gds';
import { Scalars } from '@bechtel/types';
import { SearchField } from '@bechtel/client-common';

export const listWidth = '288px';
export const smallScreenListWidth = '240px';

interface WorkPackageListContainerStyledProps {
  isDrawerOpen: Scalars['Boolean'];
}
export const WorkPackageListContainerStyled = styled.div<WorkPackageListContainerStyledProps>`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: ${listWidth};

  /* Z-index required to show box shadow on top of drawer when the drawer is open as drawer has z-index of 1.  */
  ${(props) =>
    props.isDrawerOpen &&
    css`
      z-index: 2;
    `}

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    width: ${smallScreenListWidth};
  }
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);
  color: ${({ theme }) => theme.colors.grey[1000]};
  &::before {
    box-shadow: 14px 0 12px -8px rgba(0, 0, 0, 0.1);
    content: '';
    height: 100%;
    pointer-events: none;
    position: absolute;
    right: 0;
    width: 32px;
  }
`;
export const SearchFieldStyled = styled(Box).attrs({
  mb: { sm: '400' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${IconStyled} {
    right: ${({ theme }) => theme.spacings[500]};
  }
  ${TextFieldStyled} {
    ${({ theme }) => css`
      font-size: ${theme.fontSizes[400]};
      border-color: ${theme.colors.grey[300]};
      font-family: 'Graphik';
    `}
  }
`;

export const WorkPackageListHeader = styled.div`
  padding: ${({ theme }) => theme.spacings[400]};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  z-index: 1;
`;

export const OptionsContainerStyled = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[500]};
    padding-left: ${theme.spacings[400]};
    padding-right: ${theme.spacings[400]};
  `}
`;

export const ListStyled = styled.div`
  overflow-y: auto;
  flex-grow: 1;
`;

export const NavLinkStyled = styled(NavLink)`
  border-radius: ${({ theme }) => theme.radii[200]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  color: inherit;
  display: block;
  padding-top: ${({ theme }) => theme.spacings[500]};
  padding-left: ${({ theme }) => theme.spacings[400]};
  padding-right: ${({ theme }) => theme.spacings[400]};
  padding-bottom: ${({ theme }) => theme.spacings[500]};
  position: relative;
  text-decoration: none;
  transition-timing-function: ease-in-out;
  transition-duration: 80ms;
  transition-property: background-color;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    padding-top: ${({ theme }) => theme.spacings[450]};
    padding-bottom: ${({ theme }) => theme.spacings[450]};
  }

  &:active,
  &.active,
  &:hover {
    background-color: ${({ theme }) => theme.colors.bechtel.blue[100]};
  }
`;
interface SearchCanvasButtonStyledProps {
  isDefaultFilterChange: Scalars['Boolean'];
}
export const SearchCanvasButtonStyled = styled(Button)<SearchCanvasButtonStyledProps>`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
  ${(props) =>
    props.isDefaultFilterChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
`;

export const StyledIcon = styled(Icon)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    & > svg {
      height: ${({ theme }) => theme.fontSizes[500]};
    }
  }
`;

export const WorkPackageHeaderRowStyled = styled(Box).attrs({
  py: { sm: '700' },
  pl: { sm: '600' },
  mb: { sm: '900' },
})`
  ${({ theme }) => css`
    background-image: linear-gradient(275deg, ${theme.colors.bechtel.blue[1000]}, ${theme.colors.bechtel.blue[800]});
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14);
  `}
`;
